module.exports = __webpack_public_path__ + "img/zoek-icon-bg.bc6a86bff091f36f62dccb24244eaa65.svg";